const CHANGE_COUNTRY_TEXT_MULTI = "activation.home.modal.update.country.message.multiple";
const CHANGE_COUNTRY_TEXT_SINGLE = "activation.home.modal.update.country.message";

export const TITLE = "activation.home.modal.update.country.title";

export const SAVE = "global.save";

export const getMessage = (isMultiple: boolean) =>
    isMultiple ? CHANGE_COUNTRY_TEXT_MULTI : CHANGE_COUNTRY_TEXT_SINGLE;
